import { Box, Modal } from '@mui/material';
import { AJOList, AJOState } from 'mp-js-react-auto-json-object';
import { Component } from 'react';
import { Spinner } from '../../commun/component/Spinner';
import { get } from '../../commun/HTTP';
import Result from '../../commun/Result';
import Category from '../../object/tag/Category';
import MpModal, { IBaseModalProps } from '../extends/MpModal';
import { JSXInternal } from 'preact/src/jsx';
import { SelectCategoryList } from './SelectCategoryList';

export interface ISelectCategoryModalProps extends IBaseModalProps {
    selectList: Category[];
    onSelectList: (list: Category[]) => void;
}

export interface ISelectCategoryModalState {
    selectList: Category[];
    loading: boolean;
    list: AJOState<AJOList<Category>>;
}

export default class SelectCategoryModal extends Component<ISelectCategoryModalProps, ISelectCategoryModalState> {
    constructor(props: ISelectCategoryModalProps) {
        super(props);

        this.state = this.initState();
    }

    initState() {
        const p: ISelectCategoryModalState = {
            selectList: this.props.selectList,
            loading: false,
            list: new AJOState<AJOList<Category>>(new AJOList<Category>(Category)),
        };
        p.list.setUpdate((a) => {
            this.setState({
                list: a,
            });
        });
        if (this.props.open) {
            p.loading = true;
            get('/category/list', {}).then((res: any) => {
                this.setState({
                    loading: false,
                });
                if (Result.isSuccess(res)) {
                    Result.applyResult(res, this.state.list, true);
                }
            });
        }
        return p;
    }

    componentDidUpdate(
        prevProps: Readonly<ISelectCategoryModalProps>,
        prevState: Readonly<ISelectCategoryModalState>,
        snapshot?: any,
    ): void {
        if (prevProps.open !== this.props.open) {
            this.setState(this.initState());
        }
    }

    render(): JSXInternal.Element {
        const { open, onClose } = this.props;
        const { loading } = this.state;
        return (
            <MpModal
                open={open}
                onClose={onClose}
                onSubmit={() => {
                    this.props.onSelectList(this.state.selectList);
                    onClose();
                }}
                title="Sélectionner des catégories"
                done="Sélectionner"
            >
                {loading ? (
                    <Box className="flex items-center justify-center py-12">
                        <Spinner color="blue" className="" />
                    </Box>
                ) : (
                    <SelectCategoryList
                        list={this.state.list.get()!.getList()}
                        selectList={this.state.selectList}
                        onSelectList={(list) => {
                            this.setState({
                                selectList: [...list],
                            });
                        }}
                    />
                )}
            </MpModal>
        );
    }
}
